import React from 'react';

/** A left click with no modifier held: the one the browser would follow in
 *  place rather than open in a new tab or window. */
export const isPlainLeftClick = (event: React.MouseEvent) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;
